var Marionette = require('marionette'),
    $ = require('jquery'),
    _ = require('underscore'),
    FVSettings = require('./settings'),
    LocalStorageSettings = require('./localStorageSettings'),
    User = require('./../user/userModel'),
    Viewer = require('./../viewer/viewer'),
    ReasonCodes = require('./reasonCodes/systemReasonCodes'),

    Auth = require('./authentication/authentication'),
    UnauthorizedDataModel = require('./unauthorizedData'),
    ApiUrl = require('./apiUrl'),
    Version = require('./version'),
    ChannelFns = require('./channel'),
    eqSelectors = require('../../../stylesheets/elementQuery.json'),
    SystemPrefs = require('./systemPolicies'),
    Util = require('./util'),
    DocumentCollection = require('../viewer/models/documents'), // put the models at the FV level since required here ?
    FVConstants = require('./constants');


require('jqAsyncQueue');


/*
* FV.createViewer is the entry point for end-user circumstances
* Note: required as new so this is an instance of a 'library
* */

var FV = function() {

    if (PRODUCTION) {
        this._$dfdStylesLoaded = $.Deferred();
        addStyleSheet.call(this);
    }

    /*
     * Note: could just use the window -- export would also put on window too and in IE8 can't delete the window prop
     * Need to require when pull selectors (script run order)
     * Would like to put on here, not window ... need to fix shim ?
     * */

    this.constants = FVConstants;

    this.EQ = require('elementQuery');
    this.EQ.elementQuery(eqSelectors);

    this._setWindowUnloadHandler();

    this.viewers = {};
    this.numberViewers = 0;
    this.options = null; // store the original fvOptions passed to docViewer ( necessarry to apply for viewer.openInNewWindow )
    this.settings = FVSettings;  // Note: createViewer requires some defaults set (eg, isIE8); post call, merge with plugin options
    this.localStorageSettings = LocalStorageSettings; // ( For now this class requires no instantiation )

    this.unauthorizedData = null;
    this.auth = null;   // settings must be set first for url
    this.apiURL = null;
    this.user = null; // created after get remote data
    this.systemPolicies = null;

    this.cssConstants = this._getStyleConstants(); /* Necessary for Scale Calculations (applied to all viewers) */


    /* adhoc & cache */
    this.version = null; // from file
    this.reasonCodes = null; // Note: stored here (same for all viewers), though fetched and set in Viewer Page Canvas Module

    /* Channel stored on here, can still be referenced via Radio with the name */
    var ch = this.channel = require('./radio').channel('FV');
    ch.reply(ChannelFns.requests, this);
    ch.comply(ChannelFns.commands, this);

};


function addStyleSheet() {
    // TODO: warning if not in window
     $('<link rel="stylesheet" type="text/css" href="' + __webpack_public_path__ + 'viewer.css">')
         .on('load', this._$dfdStylesLoaded.resolve).appendTo( $('head') );
}


/* Mode - States : IMPLEMENT ...
    loadingDataPlaceholder: .... for now no, 'the region will always have a background color -- '
    resetting -- no longer bkg color -- but would always have loading view '
    loggedIn, 
    loggedOut, -- can also come from auth/keep alive err -- loginView (<--viewer._exitLoggedIn)
    viewingDocument, 
    unableToLoadViewerError: 
        * create viewer: parameter validation (required, options)
        * failed db fetch
        * failed get required user data
        * failed docInfo fetch
            * failed components -- leave indicators for WF ... 
        * note: not failed login -- goes back to login view with errors
*/


 _.extend( FV.prototype, {

     docViewer: function() {

         if (DEVELOPMENT)
             return this._addViewer.apply(this, arguments);

         /* with css file applied async, only create the viewer when the styles are in the dom */
         var self = this,
             args = arguments,
             timer = setInterval( function() {

                 if ( self._$dfdStylesLoaded.state() === 'resolved' ) {
                     clearTimeout(timer);
                     return self._addViewer.apply(self, args);
                 }

             }, 100);

     },

     /*
     * Essentially the entry point for the end-user -- lib is exposed.
     * FV options kept separate as a convenience for when creating more viewers.
     * fvOptions: optional -- if passed, will override defaults; otherwise defaults or previously stored options used ( just merge instead... ) ?
     * */
     _addViewer: function(aDocReq, instanceOptions, fvOptions) {


         // Order dependent here: -- global settings on radio has path to API.
         if (fvOptions) {

             this.options = fvOptions;

             //  Really means override with defaults -- could be model and call via set.
             this.settings.initialize(fvOptions);
         }

         // Always
         this.apiURL = ApiUrl.call( ApiUrl, this.settings.PATH_TO_API );

         /*
         *  Note: viewer instances have region used for login, loading, messages, etc ... of FV namespace ( here is some coupling )
         *  Create region for db error message holder) -- note, viewer req's settings, use fn
         * */
         var viewer = new Viewer( aDocReq, instanceOptions, undefined, this.numberViewers + 1 );

         if ( !viewer.validationErr ) {
             this.numberViewers++;
             this.viewers[this.numberViewers] = viewer;
         }

         /*
         * Note: only done first time through -- also flag that the objects exist.
         * Auth model relies on gl settings.
         * */
         !this.auth && ( this.auth = new Auth() );

         !this.unauthorizedData && ( this.unauthorizedData = new UnauthorizedDataModel() ) ;

         /* Call prior to any ajax calls */
         !this.settings.$ajax.ajaxSetup && this._postValidationInit();


         !this.version && ( this.version = new Version() ); // Note: fetched on demand
         !this.reasonCodes && ( this.reasonCodes = new ReasonCodes() );

         /*     ????????????? -- need to update/clean this !!!
         *
         * TODO: on subsequent requests (not the first viewer),
         * wait to check to see if the first viewer completed before checking if .isAuthenticated
         * (that all FV data fetched -- databasesFetched, _getRemoteData).
         * unauthorizedData may not have been requested by creation of second viewer -- need to wait for next to return ( ( this.auth.isAuthenticated )
         * Alternatively hook into now existing viewer.onLoadEvent ... there's a cb function for it.
         * But actually the simple line ( isFirstViewerToLoad ) seems to work and allow for asynchronicity w/ multiple viewers --
         * what we're really looking for is whether a viewer has already been created.
         * Update --- this really needs to be looked into and cleaned up ...
         * */

         var isFirstViewerToLoad = (this.numberViewers == 1);

         var auth = this.auth,
             self = this;

         /*
          * If the first viewer, always fetch the 'unauthorizedData' -- databases are necessary to login.
          * If Not Authenticated, 401 fn will be called putting into logged out state
          * */

         if (isFirstViewerToLoad) {

             this.unauthorizedData.fetch()
                 .done( function() {

                     if ( auth.didFirstAuthenticationOccur() ) {

                         // TODO: logged in state
                         self._enterLoggedinMode();

                     } else {

                         auth.loginViaKeepAlive( self )
                             .done( self._enterLoggedinMode )
                             .fail( self._enterLoggedOutMode );  // cb should override 401 handler ...
                     }

                 })
                 .fail( function(jqXHR) {

                     // TODO: 'unableToLoadViewerError' state
                     _.invoke( self.viewers, 'triggerMethod', 'loadError',
                         'Error Fetching System Databases. Cannot Authenticate.\n' + $.fn.ajaxErrorMessage(jqXHR)
                     );

                 });
         }

         return viewer;
     },

     /*
     * Sources (4):
     * - fvChannel.userLoggedOut
     * - createViewer: if firstAuthOccured cb of successful db fetch, or cb of db fetch, then cb isAuthenticated (keepAlive)
     * - onUserLogin -- successful fetch of auth model (from login form)
     *      - improvement: call this on the channel now .... ???
     *      - first sets user auth to true, and creates a new user model
     *      - fetches user data; on success --> 'create' viewer, on fail put them in 'load error mode'
     *  call this getRequiredUserData() /  requiredAuthData() for clarity ???
     * */
     _enterLoggedinMode: function() {

        this.auth.setUserAuth(true); // ...put this in successful callback of the auth fetch

        this.systemPolicies = new SystemPrefs();

        this.systemPolicies.fetch().always( _.bind( function() {

            this.user = new User([], {
                fetchReferralGroups: this.systemPolicies.allowConsults()
            });

            this.user.fetchWithGroupsAndTaskPerms(this).done( function() {

                // Now fetch the reasonCodes; perhaps we combine with systemPolicies unauthdata/user,
                // but for now do after successful user info check.
                // We never had a fail check before when fetch from canvas module so just log a warning.
                // Plus, this will be combined later with other webservices.
                this.reasonCodes.fetch().fail( function( jqXHR ) {

                    console.warn(  $.fn.ajaxErrorMessage(jqXHR) );

                }).always( _.bind( function() {

                    _.invoke( this.viewers, 'triggerMethod', 'create' );

                }, this) );


            }).fail( function( failedRequest, jqXHR ) {

                // ...errorLoadingMode

                // if any fetch fails, fail all!
                _.invoke( this.viewers, 'triggerMethod', 'loadError',
                    'Unable to retrieve necessary user data --\nFailed ' + failedRequest + ' Request \n' + $.fn.ajaxErrorMessage(jqXHR)
                );

            });

        }, this ));

     },
     /*
     * Set user auth to false, then calls --> showLoginView.
     * Sources:
     * - 401 logout from session timeout
     * - createViewer: failed auth.isAuthenticated
     * - Failed login (fail of auth model fetch) -- this would have its own states
     * - userLoggedOut
     * - unauthorizedLogout
     * ... this also would be called during 'greedy' reset
     * TODO: abort all requests queue and stop the subsequent reqs or abort all ajax requests
     * */
     _enterLoggedOutMode: function(options) {

        var fromAuthErr = !options || (options && options.authErr);

         // Don't re-render login view if already exists (subs calls to 401)
        if (this.auth.loggedOutFromSessionTimeout() && fromAuthErr)
            return;


        this.auth.setUserAuth(false, options);

         // TODO: destroy systemPolicies?

         /*
         *  this.user.destroy(); -- note: user destroyed -- do here instead ????
         *  TODO:
         *  - destruction of modules not related to 'logged in mode'
         *  - a logout state would make clearer ( along with states for many other things here )
         * */


         // Quick hack to ensure that the resize sensor employed on the viewer's view,
         // doesn't result in a run time error when viewport is resized in logged out mode.
         // ( See viewer.channel.updateAfterViewerResize which checks for this flag ).
         // Don't disable the event on showing the loginView, may want responsive design here in the future.
         // Obvioulsy much more work required here ( tearing down modules, etc ) -- just change the is loaded flag on them for this specific error
         // Perhaps could put in the showLoginView routine ... but here is probably the place you'd want a cleanup first.
         // DVBC-1454, 172
         // Note: will need to set back to loaded on reauth, but we are already getting errors here
         if ( this.viewers['1'].state.get('viewerLoaded') ) {

             _.each( this.viewers, function(v) {
                 v.state.set('viewerLoaded', false);
             });
         }

        _.invoke( this.viewers, 'triggerMethod', 'showLoginView', this.unauthorizedData, this.auth.getLogInError() );


     },

     /**
      * From the Login Form View.
      * formData: object of key value pairs.
      */
     onUserLogin: function( formData ) {

         /*  WF easier doing this than overriding $ & BB.sync -- if using promises, the 401 CB runs with .always */
         /*  if use statusCode: {} in BB sync options, the global still gets called */
         var origStatusCode = $.ajaxSettings.statusCode;
         $.ajaxSettings.statusCode = {};

         this.auth.fetch( {
             data: formData,
             context: this
         } ).done( this._enterLoggedinMode )

            .fail( _.partial( this._enterLoggedOutMode, {authErr: true} ))

            .always( function() {
                 $.ajaxSettings.statusCode = origStatusCode;
                 this.localStorageSettings.setLastDb( formData.database );
            });

     },

     _postValidationInit: function() {
         $.support.cors = true;  // Necessary FOR IE < 10
         $.ajaxSetup( this.settings.$ajax );
     },

     /*
     * Note: will also read rules in inline tags.
     * TODO:
 *      - others: sidePane: .FV-side-{side}, width;
 *      - start using inline styles from js
     * */
     _getStyleConstants: function() {
         var cssConstants = {};
         cssConstants.V_PADDING = 10;
         cssConstants.H_PADDING = 20;
         cssConstants.THUMB_WIDTH = 110;
         return cssConstants;

     },

    /*
    * Don't need to listen to window.top if embedded: 'unload'/beforeunload' of current window seems
    * to cascade down from the parent.
    * Use unload to send ajax requests -- not beforeunload !!!
    * */
    _setWindowUnloadHandler: function() {
        $(window).on( 'unload', _.bind( this._onWindowUnload, this) );
    },
     /*
      * Exit if not authenticated ( Can't make webservice call if there's no session ).
      * Former checks whether viewer has been created (auth wouldn't exist in this case).
      * Should make private but left here to faciliate testing ( a lot of this should be made private -- DVBC-133 ).
      * May later want to expand functionality to end the user's session.
      * */

     _onWindowUnload: function(e) {

         if ( !this.auth || !this.auth.isAuthenticated() )
             return;
         _.invoke( this.viewers, 'command', 'unlockActiveDocumentBeforeUnload' );

     },

     /*
     * API: logout
     * */
     endSession: function() {
         this.auth.logOut();
     },
     /*
     * Convience method -- now used in glErrHandler
     * */
     firstViewerInstance: function() {
         return this.viewers.length < 1
            ? undefined
            :  this.viewers[_.keys(this.viewers)[0]];
     },

     /*
      * Deprecated in API in favor of createViewer.
      * */
     createViewer: function(instanceOptions, fvOptions) {
         return this.docViewer.call(this, instanceOptions.docRequest,  _.omit(instanceOptions, 'docRequest'), fvOptions);
     },

     /*
     * Scaffold: not implemented -- see DVBC-1077
     * Potentially make 'dummy viewer' to utilize the existing fn? -- need to see where auth comes into play
     * */
     comboPDF: function(aDocReq, popWindow) {
        var docs = new DocumentCollection(aDocReq);


     },
     /*
      * Probably just for test --- make 'reset' -- b/c would give clean slate.
      * More could be destroyed / reset to default state here; need to compare FV with just
      * script tag loaded vs after FV.docViewer vs FV.destory.
      * */
     destroy: function() {

         _.invoke( this.viewers, 'destroy');

         this.numberViewers = 0;
         this.options = null;

         var props = _.toArray( _.pick(this, 'settings', 'user', 'auth', 'reasonCodes', 'systemPolicies', 'unauthorizedData' ) );

         Marionette.blindTriggerOn( props, 'destroy' );
         this.channel.reset();

     }

 });


_.extend( FV.prototype, _.pick( Marionette, 'triggerMethod', 'triggerMethodOn') );


 module.exports = FV;



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/FV.js
 ** module id = 73
 ** module chunks = 0
 **/